module.exports = __webpack_public_path__ + "img/error.fdceb2dd.svg";